module.exports = __webpack_public_path__ + "media/src/images/draggable-02d55f272badc0b931c0e0df3dfca3fa.png";